import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import {
    AdvancedSnapshotMetadata,
    AdvancedSnapshotMetadataRequestParams
} from '@/pages/OperationsInsights/types/AdvancedSnapshot';
import { transformDateIntoLocalString } from '@/utils';

export async function fetchAdvancedSnapshotMetadata(
    query: AdvancedSnapshotMetadataRequestParams
): Promise<AdvancedSnapshotMetadata> {
    const fromDate = transformDateIntoLocalString(query.fromDate);
    const toDate = transformDateIntoLocalString(query.toDate);
    const params = new URLSearchParams({
        fromSnapshotDate: fromDate.split('T')[0],
        toSnapshotDate: toDate.split('T')[0],
        type: query.type,
        workstreamDefinitionIds: query.workstreamDefinitionIds?.join(',')
    });

    return fetchFromLambda(`/workactivity/back-office/backlog/advanced-snapshots/metadata?${params}`);
}